export const ELEMENT_VOCAB_IDEA_TITLE = 'title-vocab-idea';
